<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">جدول کاربران</h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style=" display: flex; align-items: center;justify-content: flex-end;">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                    
                                &nbsp;
                            </a-col>
                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                            <a-col :md="4">
                                <label class="sr-only" for="inline-form-input-name">نوع کاربر</label>
                                <select class="form-control" v-model="search.type">
                                    <option value="">انتخاب</option>
                                    <option value="admin">ادمین</option>
                                    <option value="legal">حقوقی</option>
                                    <option value="real">حقیقی</option>
                                </select>
                            </a-col>
                            <a-col :md="4">
                                <label class="sr-only" for="inline-form-input-name">
                                    موبایل</label>
                                <b-form-input v-model="search.phone" id="inline-form-input-name"
                                    class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                            </a-col>
                            <a-col :md="4">
                                <label class="sr-only" for="inline-form-input-name">ایمیل</label>
                                <b-form-input v-model="search.email" id="inline-form-input-name"
                                    class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                            </a-col>
                            <a-col :md="4">
                                <label class="sr-only" for="inline-form-input-name">نام خانوادگی</label>
                                <b-form-input v-model="search.lastname" id="inline-form-input-name"
                                    class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                            </a-col>
                            <a-col :md="4">
                                <label class="sr-only" for="inline-form-input-name">نام</label>
                                <b-form-input v-model="search.firstname" id="inline-form-input-name"
                                    class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                            </a-col>
                            <a-col :md="4">
                                <label class="sr-only" for="inline-form-input-name">کد ملی
                                </label>
                                <b-form-input v-model="search.national_code" id="inline-form-input-name"
                                    class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                            </a-col>
                            <a-col style="margin-top: 20px" :md="4">
                                <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                    جستجو
                                </a-button>

                            </a-col>
                    </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                            <div class="table-responsive">
                                <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">کاربر</th>
                                        <th scope="col">نوع کاربری</th>
                                        <th scope="col">موجودی کیف پول</th>
                                        <th scope="col">موجودی تهاتری</th>
                                        <th scope="col">سرمایه اولیه</th>
                                        <th scope="col">نمایش خدمات دهنده</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row . id }}</th>
                                        <td>
                                            <b-avatar size="1.5rem" :src="$root.image_concat(row.image)"></b-avatar>

                                            <b-badge variant="light" class="text-dark">
                                                {{ row . firstname + ' ' + row . lastname }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge v-if="row.type == 'admin'" variant="light" class="bg-secondary">
                                                ادمین</b-badge>
                                            <b-badge v-else-if="row.type == 'legal'" variant="light"
                                                class="bg-secondary">حقوقی</b-badge>
                                            <b-badge v-else variant="light" class="bg-secondary">حقیقی</b-badge>
                                        </td>

                                        <td>
                                            <b-badge pill variant="info" class="bg-success">
                                                {{ $root . number_format(row . wallet) }}
                                            </b-badge>
                                        </td>
                                        <td>
                                            <b-badge pill variant="info" class="bg-info">
                                                {{ $root . number_format(row . barter) }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge pill variant="info" class="bg-primary">
                                                {{ $root . number_format(row . investment) }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge v-if="row.information" :variant="row.information.is_provider_visible ? 'success' : 'secondary'">
                                                {{ row.information.is_provider_visible ? 'نمایش داده می شود' : 'مخفی شده' }}
                                            </b-badge>
                                            <b-badge v-else variant="light" class="text-dark">
                                                پروفایل خدمات دهنده ندارد
                                            </b-badge>
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <a-button class="btn-outline-primary" shape="square"
                                                :href="'/financials/transactions/' + row.id"
                                                v-show="$root.hasPermission('/financials/transactions/')"> لیست تراکنش ها</a-button>
                                            &nbsp;
                                            <ModalChange @getData="getData" :userId="row.id"
                                             v-show="$root.hasPermission('/financials/changeDeposite/')" />
                                            &nbsp;
                                            <a-button v-if="row.information && row.information.is_provider_visible"
                                                class="btn-outline-danger"
                                                shape="square"
                                                icon="eye-invisible"
                                                @click="toggleProviderVisibility(row)">
                                                حذف از خدمات دهندگان
                                            </a-button>
                                            <a-button v-else-if="row.information"
                                                class="btn-outline-success"
                                                shape="square"
                                                icon="eye"
                                                @click="toggleProviderVisibility(row)">
                                                نمایش در خدمات دهندگان
                                            </a-button>
                                            </div>
                                        
                                        </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>
<script>
    import ModalChange from "../../components/Financials/ModalChange.vue"

    export default {
        components: {
            ModalChange,
        },
        data() {
            return {
                data: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                    firstname: "",
                    lastname: "",
                    type: "",
                    phone: "",
                    email: "",
                    national_code: "",
                },
            };
        },
        methods: {
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/users?page=${this.currentPage}&&firstname=${this.search.firstname}&&lastname=${this.search.lastname}&&type=${this.search.type}&&phone=${this.search.phone}&&email=${this.search.email}&&national_code=${this.search.national_code}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        console.log(response)
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            toggleProviderVisibility(row) {
                const shouldHide = row.information && row.information.is_provider_visible;
                this.$swal({
                    title: shouldHide ? "این کاربر از لیست خدمات دهندگان حذف شود؟" : "این کاربر در لیست خدمات دهندگان نمایش داده شود؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        this.$store.state.loading = true;
                        axios
                            .post(`/users/provider-visibility/${row.id}`)
                            .then(function() {
                                _this.$toast.success("وضعیت نمایش خدمات دهنده با موفقیت ویرایش شد.");
                                _this.getData();
                            })
                            .catch(function(err) {
                                _this.$store.state.loading = false;
                                _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
        },
        mounted() {
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
